// extracted by mini-css-extract-plugin
export var brandingImg = "Markdown-module--branding-img--bfcfe";
export var root = "Markdown-module--root--9f319";